export default __webpack_public_path__ + "static/media/postgreSQL.dac6eda7.svg";